import React from 'react';
import { messages } from '../../common/messages';
import VideoListSlider from './VideoListSlider';
import { Col } from 'reactstrap';
import { removeSuffix, slugifyHeader } from '../../common/function';
import { CAPSULE_VIDEO_ID } from '../../common/constant';

// Per-item subscribed flag — matches VideoListSlider. Non-webinar items
// resolve to the caller's `isUserSubscribed` (byte-identical historical
// behavior). Webinars require Unlimited+ (`hasPlusAccess`).
const itemSubscribed = (item, isUserSubscribed, hasPlusAccess) => (
  item && item.media_type === 'webinar' ? !!hasPlusAccess : !!isUserSubscribed
);

const VideoCard = ({
  index,
  currentItem,
  chapterIdKey = 'id',
  chapterNameKey = 'name',
  videoTableNameKey,
  isUserSubscribed = false,
  // Unlimited+ marker used only by the Live Sessions (`media_type='webinar'`)
  // gate inside VideoListSlider. Optional so non-CFA1-2025 callers (FRM etc.)
  // that don't need per-item webinar handling can omit it.
  hasPlusAccess = false,
  redirectToPlaylist,
  premiumModalToggle,
}) => {
  const isFRMChapter =
    currentItem.chapter_id === CAPSULE_VIDEO_ID || currentItem.id === CAPSULE_VIDEO_ID;

  const hasCFAVideosAndMock =
    currentItem['cfa1_2025_videos'] && currentItem.mock_id;

  const hasFRMVideos = !!currentItem['frm_videos'];

  const chapterName = currentItem[chapterNameKey];
  const chapterNameNoSuffix = removeSuffix(chapterName, '– volume');

  let displayName;
  if (hasCFAVideosAndMock) {
    displayName = chapterName;
  } else if (!currentItem.case_id) {
    displayName = isFRMChapter
      ? chapterName
      : `${hasFRMVideos ? messages.BOOK : messages.TOPIC} ${index} - ${chapterName}`;
  } else {
    displayName = isFRMChapter
      ? chapterNameNoSuffix
      : `${hasFRMVideos ? messages.BOOK : messages.TOPIC} ${index} - ${chapterNameNoSuffix}`;
  }
  return currentItem.headerTitle ? (
    <Col sm={12} md={12} key={index}>
      <div className='video-header-title' id={slugifyHeader(currentItem.headerTitle)}>
        <i className='fa fa-caret-square-o-right' /> <span>{currentItem.headerTitle}</span>
      </div>
    </Col>
  ) : (
    <Col sm={12} md={12} key={index}>
      <div className='card'>
        <div
          className='card-header card_header_bg'
          value={currentItem[chapterIdKey]}
          // onClick={() => redirectToPlaylist(currentItem[videoTableNameKey][0])}
          onClick={() => {
            // Same shape as the historical header handler — a single ternary,
            // no restructured JSX. Just extends the "can play the first
            // video" test to respect the Plus tier for webinars, so a non-
            // Plus user clicking a paid-webinar chapter header opens the
            // upgrade modal instead of navigating and being bounced back.
            const firstVideo = currentItem[videoTableNameKey]
              && currentItem[videoTableNameKey][0];
            const isSubscribedForFirst = itemSubscribed(
              firstVideo, isUserSubscribed, hasPlusAccess,
            );
            return firstVideo && (isSubscribedForFirst || firstVideo.free)
              ? redirectToPlaylist(firstVideo)
              : premiumModalToggle && premiumModalToggle();
          }}
        >
            <a
              className='pointer_class'
              id={currentItem[chapterNameKey]}
              value={currentItem[chapterIdKey]}
            >
              {displayName}
            </a>

        </div>
        <div className='card-block list_icon_outer' key={currentItem[chapterNameKey]}>
          {currentItem[videoTableNameKey].length > 0 ? (
            <p>
              {messages.TOTAL_VIDEOS}: {currentItem[videoTableNameKey].length}
            </p>
          ) : (
            <p />
          )}
          <Col xs={12} sm={12} md={12} key={index}>
            <VideoListSlider
              key={currentItem[chapterIdKey]}
              videos={currentItem[videoTableNameKey]}
              isUserSubscribed={isUserSubscribed}
              hasPlusAccess={hasPlusAccess}
              premiumModalToggle={premiumModalToggle}
              redirectToPlaylist={redirectToPlaylist}
            />
          </Col>
        </div>
      </div>
    </Col>
  );
};

export default VideoCard;



// WEBPACK FOOTER //
// ./src/Components-2025/Videos/videoCard.js